import {FC, ReactNode, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
//store
import {orgStorage} from '@/utils/services/storage.service';
//enums
import {ROUTER_URL, STORAGE_KEY} from '@/utils/enums';

interface OrganizationAuthPrivateRouteProps {
	children: ReactNode;
}

const OrganizationAuthPrivateRoute: FC<OrganizationAuthPrivateRouteProps> = ({children}) => {
	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const organizationId = orgStorage.get(STORAGE_KEY.ORGANIZATION_ID);

		if (organizationId) {
			navigate(ROUTER_URL.ORGANIZATION);
		}

		setIsLoading(false);
	}, []);

	return !isLoading && children;
};

export default OrganizationAuthPrivateRoute;
